'use client';

import { ShopCurationEdit } from './ShopCurationEdit';

interface ShopEditProps {
  curationId: string;
}

export function ShopEdit({ curationId }: ShopEditProps) {
  return <ShopCurationEdit curationId={curationId} />;
}
